import Vue from 'vue'
import Vuex from 'vuex'

// Shared
import * as constants from './constants'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// Modules
import air from './modules/air'
import notification from './modules/notification'
import land_movement from './modules/land_movement'
import sea from './modules/sea'
import temp_venue from './modules/temp_venue'
import nsl from './modules/nsl'
import mofa from './modules/mofa'
import user from './modules/user'
import VuexPersist from 'vuex-persist'

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'decon', // The key to store the state on in the storage provider.
  storage: window.localStorage,
  reducer: state => ({
     userId: state.userId,
     username: state.username,
     firstname: state.firstname,
     lastname: state.lastname,
     token: state.token,
     permission: state.permission,
     agencyId: state.agencyId,
     agencyName: state.agencyName,
     notificationId: state.notificationId,
     requestTypeId: state.requestTypeId,    
     purposeId: state.purposeId,
     purposeOthers: state.purposeOthers,
     detailsNotification: state.detailsNotification,
     requestTypeId: state.requestTypeId,
     map: state.map,
     waypoints: state.waypoints,
     ehocRef: state.ehocRef,
     nv_for: state.nv_for,
     nv_number: state.nv_number,
     requestedBy: state.requestedBy,
     lastUpdatedBy: state.lastUpdatedBy,
     notes: state.notes,
     statusId: state.statusId,
     purposeList: state.purposeList,
     agencyList: state.agencyList,    
     requestTypeList: state.requestTypeList,
     statusList: state.statusList,
     modified: state.modified,
     map_modified: state.map_modified,
     viewMofa: state.viewMofa,
     land_movement: state.land_movement,
     temp_venue: state.temp_venue,
     usageList: state.usageList,
     clearanceList: state.clearanceList,
     requestList: state.requestList,
     operatorList: state.operatorList,
     facilityTypeList: state.facilityTypeList,
     siteTypeList: state.siteTypeList,
     attachmentList:  state.attachmentList,
     new_notification: state.new_notification,
     start_date: state.start_date,
     isOrgAnonymous: state.isOrgAnonymous,
     submittedId: state.submittedId,
     sea: state.sea,
     mofa: state.mofa,
     air: state.air,
     nsl: state.nslList,
     user: state.user
  })
})  

export default new Vuex.Store({
  state: constants.initialState,
  actions,
  getters,
  mutations,
  modules: {
    notification: notification,
    land_movement: land_movement,
    temp_venue: temp_venue,
    sea: sea,
    air: air,
    nsl: nsl,
    mofa: mofa,
    user: user

  },
  plugins: [vuexLocalStorage.plugin]
})


// WEBPACK FOOTER //
// ./src/store/index.js